const UrlUtil = {
  keyExistsInUrl: (url: string, key: string) => {
    const patt = `${key}=`;
    const re = new RegExp(patt, 'i');
    return re.test(url);
  },

  getParam: (key: string, url?: string): string | null => {
    if (!url) {
      const searchParams = new URLSearchParams(window.location.search.toLowerCase());
      return searchParams.get(key.toLowerCase());
    }

    if (url && UrlUtil.keyExistsInUrl(url, key)) {
      const patt = `${key}=([^&|\\s]+)`;
      const re = new RegExp(patt, 'i');
      const match = url.match(re);
      return match[1] || null;
    }

    return null;
  },
};

export default UrlUtil;
